<template>
    <div>
        <!-- global block overlay while any windowsDialog is open -->
        <div v-if="openPopups.length" class="blocker"></div>

        <!-- render one overlay per opened windowsDialog (stackable) -->
        <div v-for="p in openPopups" :key="p.id" class="windowsDialog-ov" tabindex="0">
            <div class="windowsDialog" :style="p.style">
                <img :src="p.image" @click="closePopup(p.id)" @dragstart.prevent @contextmenu.prevent
                    ondragstart="return false;" alt="" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PopUpTrap',
    emits: ['done'],
    data() {
        return {
            timers: [],
            openPopups: [],
            startedAt: null,
            fired: 0,
            audio: null, // Hinzufügen eines Audio-Objekts
            schedule: [
                { image: require('@/assets/windowsDialoge/error.png'), time: 16358, x: 18, y: 18 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 16660, x: 20, y: 20 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 16962, x: 22, y: 22 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 17264, x: 24, y: 24 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 17415, x: 26, y: 26 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 17566, x: 28, y: 28 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 17868, x: 30, y: 30 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 18762, x: 88, y: 92 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 19064, x: 90, y: 94 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 19354, x: 92, y: 96 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 19656, x: 94, y: 94 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 19818, x: 96, y: 92 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 19969, x: 94, y: 90 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 20259, x: 92, y: 88 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 20561, x: 90, y: 86 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 21165, x: 70, y: 25 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 21467, x: 72, y: 27 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 21757, x: 74, y: 29 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 22059, x: 76, y: 31 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 22210, x: 78, y: 33 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 22361, x: 80, y: 35 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 22663, x: 82, y: 37 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 23568, x: 50, y: 58 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 23870, x: 52, y: 60 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 24160, x: 54, y: 62 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 24462, x: 56, y: 64 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 24613, x: 58, y: 66 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 24787, x: 60, y: 68 },
                { image: require('@/assets/windowsDialoge/taskfailed.png'), time: 25530, x: 12, y: 80 },
                { image: require('@/assets/windowsDialoge/pleasereboot.jpg'), time: 26726, x: 85, y: 32 },
                { image: require('@/assets/windowsDialoge/pleasereboot.jpg'), time: 27028, x: 87, y: 34 },
                { image: require('@/assets/windowsDialoge/fix.png'), time: 27934, x: 42, y: 86 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 29129, x: 17, y: 18 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 29431, x: 19, y: 20 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 30325, x: 87, y: 92 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 31533, x: 69, y: 25 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 31823, x: 71, y: 27 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 32740, x: 49, y: 58 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 33042, x: 51, y: 60 },
                { image: require('@/assets/windowsDialoge/taskfailed.png'), time: 33959, x: 11, y: 80 },
                { image: require('@/assets/windowsDialoge/taskfailed.png'), time: 34261, x: 14, y: 82 },
                { image: require('@/assets/windowsDialoge/pleasereboot.jpg'), time: 35178, x: 84, y: 32 },
                { image: require('@/assets/windowsDialoge/fix.png'), time: 36084, x: 41, y: 86 },
                { image: require('@/assets/windowsDialoge/fix.png'), time: 36223, x: 44, y: 88 },
                { image: require('@/assets/windowsDialoge/fix.png'), time: 36386, x: 46, y: 90 },
                { image: require('@/assets/windowsDialoge/fix.png'), time: 36479, x: 48, y: 92 },
                { image: require('@/assets/windowsDialoge/fix.png'), time: 36571, x: 50, y: 94 },
                { image: require('@/assets/windowsDialoge/fix.png'), time: 36699, x: 52, y: 96 },
                { image: require('@/assets/windowsDialoge/fix.png'), time: 36978, x: 54, y: 94 },
                { image: require('@/assets/windowsDialoge/fix.png'), time: 37129, x: 56, y: 92 },
                { image: require('@/assets/windowsDialoge/fix.png'), time: 37280, x: 58, y: 90 },
                { image: require('@/assets/windowsDialoge/fix.png'), time: 37373, x: 60, y: 88 },
                { image: require('@/assets/windowsDialoge/fix.png'), time: 37581, x: 62, y: 86 },
                { image: require('@/assets/windowsDialoge/fix.png'), time: 37721, x: 64, y: 84 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 37860, x: 18, y: 17 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 38185, x: 20, y: 19 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 38290, x: 21, y: 22 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 38406, x: 23, y: 24 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 38557, x: 25, y: 26 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 38684, x: 27, y: 28 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 38777, x: 29, y: 30 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 38882, x: 32, y: 32 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 39044, x: 34, y: 34 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 39172, x: 36, y: 36 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 39277, x: 38, y: 38 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 39404, x: 40, y: 40 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 39532, x: 88, y: 91 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 39683, x: 89, y: 94 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 39985, x: 91, y: 96 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 40124, x: 93, y: 94 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 40263, x: 95, y: 92 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 40380, x: 93, y: 90 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 40577, x: 91, y: 88 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 40681, x: 89, y: 86 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 40879, x: 88, y: 84 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 41018, x: 86, y: 82 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 41204, x: 84, y: 80 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 41355, x: 82, y: 78 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 41448, x: 70, y: 24 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 41564, x: 72, y: 26 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 41784, x: 73, y: 29 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 41935, x: 75, y: 31 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 42086, x: 77, y: 33 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 42376, x: 79, y: 35 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 42504, x: 81, y: 37 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 42655, x: 84, y: 39 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 42992, x: 86, y: 41 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 43085, x: 88, y: 43 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 43224, x: 90, y: 45 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 43363, x: 92, y: 47 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 43491, x: 50, y: 57 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 43607, x: 52, y: 59 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 43735, x: 53, y: 62 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 43862, x: 55, y: 64 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 43967, x: 57, y: 66 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 44188, x: 59, y: 68 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 44327, x: 62, y: 70 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 44478, x: 64, y: 72 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 44780, x: 66, y: 74 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 44931, x: 68, y: 76 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 45070, x: 70, y: 78 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 45174, x: 72, y: 80 },
                { image: require('@/assets/windowsDialoge/taskfailed.png'), time: 45383, x: 12, y: 79 },
                { image: require('@/assets/windowsDialoge/taskfailed.png'), time: 45488, x: 13, y: 82 },
                { image: require('@/assets/windowsDialoge/taskfailed.png'), time: 45604, x: 16, y: 84 },
                { image: require('@/assets/windowsDialoge/taskfailed.png'), time: 45755, x: 18, y: 86 },
                { image: require('@/assets/windowsDialoge/taskfailed.png'), time: 45883, x: 20, y: 88 },
                { image: require('@/assets/windowsDialoge/taskfailed.png'), time: 45976, x: 22, y: 90 },
                { image: require('@/assets/windowsDialoge/taskfailed.png'), time: 46080, x: 24, y: 92 },
                { image: require('@/assets/windowsDialoge/taskfailed.png'), time: 46266, x: 26, y: 94 },
                { image: require('@/assets/windowsDialoge/taskfailed.png'), time: 46370, x: 28, y: 96 },
                { image: require('@/assets/windowsDialoge/taskfailed.png'), time: 46579, x: 30, y: 94 },
                { image: require('@/assets/windowsDialoge/taskfailed.png'), time: 46730, x: 32, y: 92 },
                { image: require('@/assets/windowsDialoge/taskfailed.png'), time: 46893, x: 34, y: 90 },
                { image: require('@/assets/windowsDialoge/pleasereboot.jpg'), time: 47183, x: 85, y: 31 },
                { image: require('@/assets/windowsDialoge/pleasereboot.jpg'), time: 47322, x: 86, y: 34 },
                { image: require('@/assets/windowsDialoge/pleasereboot.jpg'), time: 47462, x: 89, y: 36 },
                { image: require('@/assets/windowsDialoge/pleasereboot.jpg'), time: 47787, x: 91, y: 38 },
                { image: require('@/assets/windowsDialoge/pleasereboot.jpg'), time: 47891, x: 93, y: 40 },
                { image: require('@/assets/windowsDialoge/pleasereboot.jpg'), time: 48077, x: 95, y: 42 },
                { image: require('@/assets/windowsDialoge/pleasereboot.jpg'), time: 48205, x: 95, y: 44 },
                { image: require('@/assets/windowsDialoge/pleasereboot.jpg'), time: 48414, x: 93, y: 46 },
                { image: require('@/assets/windowsDialoge/pleasereboot.jpg'), time: 48565, x: 91, y: 48 },
                { image: require('@/assets/windowsDialoge/pleasereboot.jpg'), time: 48692, x: 89, y: 50 },
                { image: require('@/assets/windowsDialoge/pleasereboot.jpg'), time: 48855, x: 87, y: 52 },
                { image: require('@/assets/windowsDialoge/pleasereboot.jpg'), time: 49006, x: 85, y: 54 },
                { image: require('@/assets/windowsDialoge/fix.png'), time: 49133, x: 42, y: 85 },
                { image: require('@/assets/windowsDialoge/fix.png'), time: 49284, x: 43, y: 88 },
                { image: require('@/assets/windowsDialoge/fix.png'), time: 49575, x: 45, y: 90 },
                { image: require('@/assets/windowsDialoge/fix.png'), time: 49726, x: 47, y: 92 },
                { image: require('@/assets/windowsDialoge/fix.png'), time: 49865, x: 49, y: 94 },
                { image: require('@/assets/windowsDialoge/fix.png'), time: 49969, x: 51, y: 96 },
                { image: require('@/assets/windowsDialoge/fix.png'), time: 50178, x: 53, y: 94 },
                { image: require('@/assets/windowsDialoge/fix.png'), time: 50283, x: 55, y: 92 },
                { image: require('@/assets/windowsDialoge/fix.png'), time: 50480, x: 57, y: 90 },
                { image: require('@/assets/windowsDialoge/fix.png'), time: 50631, x: 59, y: 88 },
                { image: require('@/assets/windowsDialoge/fix.png'), time: 50805, x: 61, y: 86 },
                { image: require('@/assets/windowsDialoge/fix.png'), time: 50945, x: 63, y: 84 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 51049, x: 18, y: 19 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 51165, x: 20, y: 21 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 51386, x: 22, y: 21 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 51525, x: 24, y: 23 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 51688, x: 26, y: 25 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 51978, x: 28, y: 27 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 52117, x: 30, y: 29 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 52257, x: 31, y: 32 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 52593, x: 33, y: 34 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 52686, x: 35, y: 36 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 52883, x: 37, y: 38 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 53023, x: 39, y: 40 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 53209, x: 88, y: 93 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 53336, x: 90, y: 93 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 53464, x: 92, y: 95 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 53568, x: 94, y: 93 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 53673, x: 96, y: 91 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 53789, x: 94, y: 89 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 53928, x: 92, y: 87 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 54079, x: 90, y: 85 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 54381, x: 87, y: 84 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 54973, x: 85, y: 82 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 55275, x: 83, y: 80 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 55577, x: 81, y: 78 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 55681, x: 70, y: 26 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 56192, x: 72, y: 28 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 56332, x: 74, y: 28 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 56483, x: 76, y: 30 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 56784, x: 78, y: 32 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 57458, x: 50, y: 59 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 57678, x: 52, y: 61 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 57945, x: 54, y: 61 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 58061, x: 56, y: 63 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 58572, x: 58, y: 65 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 58712, x: 60, y: 67 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 58863, x: 61, y: 70 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 59164, x: 63, y: 72 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 59757, x: 65, y: 74 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 60058, x: 67, y: 76 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 60360, x: 69, y: 78 },
                { image: require('@/assets/windowsDialoge/taskfailed.png'), time: 60453, x: 12, y: 81 },
                { image: require('@/assets/windowsDialoge/taskfailed.png'), time: 60964, x: 14, y: 81 },
                { image: require('@/assets/windowsDialoge/taskfailed.png'), time: 61103, x: 15, y: 84 },
                { image: require('@/assets/windowsDialoge/taskfailed.png'), time: 61266, x: 17, y: 86 },
                { image: require('@/assets/windowsDialoge/taskfailed.png'), time: 61556, x: 19, y: 88 },
                { image: require('@/assets/windowsDialoge/pleasereboot.jpg'), time: 62183, x: 85, y: 33 },
                { image: require('@/assets/windowsDialoge/pleasereboot.jpg'), time: 62404, x: 87, y: 33 },
                { image: require('@/assets/windowsDialoge/fix.png'), time: 63054, x: 42, y: 87 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 63658, x: 19, y: 18 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 63959, x: 21, y: 20 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 64250, x: 22, y: 23 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 65457, x: 89, y: 92 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 67860, x: 71, y: 25 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 69056, x: 51, y: 58 },
                { image: require('@/assets/windowsDialoge/taskfailed.png'), time: 70252, x: 13, y: 80 },
                { image: require('@/assets/windowsDialoge/pleasereboot.jpg'), time: 71459, x: 86, y: 32 },
                { image: require('@/assets/windowsDialoge/fix.png'), time: 74501, x: 43, y: 86 },
                { image: require('@/assets/windowsDialoge/fix.png'), time: 74664, x: 44, y: 87 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 75709, x: 16, y: 18 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 76011, x: 18, y: 20 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 76127, x: 23, y: 22 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 76278, x: 24, y: 25 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 76916, x: 86, y: 92 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 78100, x: 68, y: 25 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 78402, x: 73, y: 27 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 78507, x: 74, y: 30 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 78634, x: 76, y: 32 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 79319, x: 48, y: 58 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 79470, x: 53, y: 60 },
                { image: require('@/assets/windowsDialoge/taskfailed.png'), time: 80504, x: 10, y: 80 },
                { image: require('@/assets/windowsDialoge/pleasereboot.jpg'), time: 81723, x: 83, y: 32 },
                { image: require('@/assets/windowsDialoge/fix.png'), time: 82907, x: 40, y: 86 },
                { image: require('@/assets/windowsDialoge/fix.png'), time: 83209, x: 44, y: 89 },
                { image: require('@/assets/windowsDialoge/fix.png'), time: 83302, x: 46, y: 89 },
                { image: require('@/assets/windowsDialoge/fix.png'), time: 83429, x: 48, y: 91 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 84114, x: 17, y: 17 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 84207, x: 19, y: 19 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 84335, x: 20, y: 22 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 85310, x: 87, y: 91 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 85449, x: 90, y: 95 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 86529, x: 69, y: 24 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 86622, x: 70, y: 27 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 86750, x: 75, y: 29 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 87702, x: 49, y: 57 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 87806, x: 50, y: 60 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 87980, x: 54, y: 63 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 88085, x: 56, y: 65 },
                { image: require('@/assets/windowsDialoge/wordpad.png'), time: 88282, x: 58, y: 67 },
                { image: require('@/assets/windowsDialoge/taskfailed.png'), time: 88944, x: 11, y: 79 },
                { image: require('@/assets/windowsDialoge/taskfailed.png'), time: 89083, x: 14, y: 83 },
                { image: require('@/assets/windowsDialoge/pleasereboot.jpg'), time: 90105, x: 84, y: 31 },
                { image: require('@/assets/windowsDialoge/pleasereboot.jpg'), time: 90395, x: 87, y: 35 },
                { image: require('@/assets/windowsDialoge/fix.png'), time: 91301, x: 41, y: 85 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 92497, x: 17, y: 19 },
                { image: require('@/assets/windowsDialoge/error.png'), time: 92799, x: 19, y: 21 },
                { image: require('@/assets/windowsDialoge/calc.webp'), time: 93704, x: 87, y: 93 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 94912, x: 69, y: 26 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 95202, x: 71, y: 26 },
                { image: require('@/assets/windowsDialoge/localdisk.png'), time: 95295, x: 72, y: 29 },
            ],
        };
    },
    mounted() {
        document.addEventListener('click', this.handleUserInteraction, { once: true });
        this.start();
    },
    methods: {
        handleUserInteraction() {
            // Nach Interaktion Audio abspielen
            const audio = new Audio(require('@/assets/windowsDialoge/xp.mp3'));
            audio.play()
                .catch((err) => console.error('Fehler beim Starten des Sounds:', err));
        },
        start(base = performance.now()) {
            this.stop();
            this.startedAt = base;
            this.fired = 0;
            const now = performance.now();
            this.schedule.forEach((entry, i) => {
                const delay = Math.max(0, (this.startedAt + Number(entry.time || 0)) - now);
                const id = setTimeout(() => {
                    this.fired++;
                    this.open(entry, i);
                }, delay);
                this.timers.push(id);
            });
        },
        stop() {
            this.timers.forEach(t => clearTimeout(t));
            this.timers = [];
            this.startedAt = null;
        },
        open(entry, idx) {
            const x = typeof entry.x === 'number' ? entry.x : 50;
            const y = typeof entry.y === 'number' ? entry.y : 50;
            const windowsDialog = {
                id: Date.now() + Math.random(),
                image: entry.image,
                style: {
                    position: 'absolute',
                    left: `${x}%`,
                    top: `${y}%`,
                    transform: 'translate(-50%, -50%)'
                },
                idx
            };
            this.openPopups.push(windowsDialog);
            this.$nextTick(() => {
                const nodes = document.querySelectorAll('.windowsDialog-ov');
                if (nodes && nodes.length) nodes[nodes.length - 1].focus();
            });
        },
        closePopup(id) {
            console.log('closePopup', id);
            const i = this.openPopups.findIndex(p => p.id === id);
            if (i !== -1) {
                this.openPopups.splice(i, 1);
            }
            if (this.openPopups.length < 1) {
                this.$emit('done');
            }
            if (i === -1) return;
        }
    }
};
</script>

<style scoped>
.blocker {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 30000;
    pointer-events: auto;
}

.windowsDialog-ov {
    position: fixed;
    inset: 0;
    z-index: 30010;
    pointer-events: none;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
}

.windowsDialog {
    pointer-events: auto;
    border-radius: 6px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
    max-width: 420px;
    max-height: 80vh;
}

.windowsDialog img {
    display: block;
    max-width: 100%;
    max-height: 70vh;
    border-radius: 4px;
}

.close {
    position: absolute;
    right: 6px;
    top: 6px;
    height: 40px;
    background: transparent;
    border: 0;
    color: #fff;
    cursor: pointer;
    font-size: 14px;
}
</style>